import { render } from "./GiveUpToast.vue?vue&type=template&id=3e01e81b&scoped=true"
import script from "./GiveUpToast.vue?vue&type=script&lang=js"
export * from "./GiveUpToast.vue?vue&type=script&lang=js"

import "./GiveUpToast.vue?vue&type=style&index=0&id=3e01e81b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e01e81b"]])

export default __exports__